import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { Heart } from "lucide-react";
import SeoHead from "@/components/SeoHead";
import LanguageSwitcher from "@/components/LanguageSwitcher";
import supporters from "@/config/supporters.json";

const TIERS = ["patron", "founder", "supporter"] as const;

/** 支持者名单（数据来自 src/config/supporters.json，众筹结束后手工填写） */
export default function SupportersPage() {
  const { t } = useTranslation();
  const data = supporters as Record<(typeof TIERS)[number], string[]>;
  const total = TIERS.reduce((n, k) => n + (data[k]?.length ?? 0), 0);

  return (
    <div className="min-h-screen bg-white flex flex-col">
      <SeoHead
        path="supporters"
        title="サポーターの皆さま - BamaBang"
        description="Thank you to everyone who backed BamaBang through crowdfunding."
      />
      <header className="bg-white border-b border-gray-200">
        <div className="max-w-3xl mx-auto px-4 py-4 flex items-center justify-between">
          <Link to="/" className="flex items-center gap-3">
            <img src="/favicon.png" alt="Logo" className="w-9 h-9" />
            <span className="font-bold text-gray-900">BamaBang</span>
          </Link>
          <LanguageSwitcher />
        </div>
      </header>

      <main className="flex-1 max-w-3xl w-full mx-auto px-6 py-12">
        <div className="text-center mb-10">
          <Heart className="w-10 h-10 text-pink-500 mx-auto mb-3" />
          <h1 className="text-3xl font-bold text-gray-900 mb-2">{t("supporters.title")}</h1>
          <p className="text-gray-600">{t("supporters.subtitle")}</p>
        </div>

        {total === 0 ? (
          <p className="text-center text-gray-500">{t("supporters.empty")}</p>
        ) : (
          <div className="space-y-10">
            {TIERS.map((tier) =>
              (data[tier]?.length ?? 0) > 0 ? (
                <section key={tier}>
                  <h2 className="text-lg font-semibold text-pink-600 mb-3 text-center">
                    {t(`supporters.${tier}`)}
                  </h2>
                  <ul className="flex flex-wrap justify-center gap-x-6 gap-y-2 text-gray-800">
                    {data[tier].map((name, i) => (
                      <li key={`${tier}-${i}`}>{name}</li>
                    ))}
                  </ul>
                </section>
              ) : null,
            )}
          </div>
        )}

        <div className="text-center mt-12">
          <Link to="/" className="text-sm text-gray-500 hover:text-pink-600">
            {t("supporters.back_home")}
          </Link>
        </div>
      </main>
    </div>
  );
}
